"use strict";
/**
 * 公告模块&方法
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadlyVideo = exports.getZhiboCover = void 0;
var reactvideo_1 = __importDefault(require("../../../../modules/video/reactvideo")); //视频组件
/**
* 获取直播封面 h_cover > cover > v_cover
*/
function getZhiboCover(data) {
    if (data === null || data === void 0 ? void 0 : data.h_cover) {
        return data.h_cover;
    }
    if (data === null || data === void 0 ? void 0 : data.cover) {
        return data.cover;
    }
    return (data === null || data === void 0 ? void 0 : data.v_cover) || "";
}
exports.getZhiboCover = getZhiboCover;
/**
 *  路演视频
 * @param src 视频地址
 * @param {*} ctx 上下文this信息
 * @param {*} data 综合数据
 * @param {*} src
 * @param {*} vdparams  播放器参数
 * @param {*} _env
 * @param {*} rtcinfos 直播测试相关信息
 * @returns
 **/
function loadlyVideo(avboxid, data, src, vdparams, _env, rtcinfos) {
    if (!src)
        return false;
    var boxId = avboxid || "lyav-player-ctx";
    // console.log(vdparams)
    // $("#vedio-wrap").css({ "min-height": "366px" });
    if ($("#".concat(boxId)).length < 1) {
        return false;
    }
    var defaultparams = {
        dataall: data,
        status: data.status,
        poster: getZhiboCover(data),
        boxid: boxId,
        width: 650,
        height: 366,
        autoplay: false,
        muted: false,
        bigPlayButton: true,
        src: src,
        env: _env,
        scalable: true,
        rtcinfos: rtcinfos
    };
    var opt = $.extend({}, defaultparams, vdparams);
    (0, reactvideo_1.default)(opt);
}
exports.loadlyVideo = loadlyVideo;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7O0dBRUc7Ozs7OztBQUVILG9GQUE0RCxDQUFDLE1BQU07QUFFbkU7O0VBRUU7QUFDRixTQUFnQixhQUFhLENBQUMsSUFBUztJQUVyQyxJQUFJLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxPQUFPLEVBQUU7UUFDakIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFBO0tBQ3BCO0lBRUQsSUFBSSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsS0FBSyxFQUFFO1FBQ2YsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFBO0tBQ2xCO0lBRUQsT0FBTyxDQUFBLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxPQUFPLEtBQUksRUFBRSxDQUFBO0FBQzVCLENBQUM7QUFYRCxzQ0FXQztBQUVEOzs7Ozs7Ozs7O0lBVUk7QUFFSixTQUFnQixXQUFXLENBQUMsT0FBWSxFQUFFLElBQVMsRUFBRSxHQUFXLEVBQUUsUUFBYSxFQUFFLElBQVksRUFBRSxRQUFpQjtJQUM5RyxJQUFJLENBQUMsR0FBRztRQUFHLE9BQU8sS0FBSyxDQUFDO0lBRXhCLElBQUksS0FBSyxHQUFHLE9BQU8sSUFBSSxpQkFBaUIsQ0FBQztJQUV6Qyx3QkFBd0I7SUFFeEIsbURBQW1EO0lBRW5ELElBQUcsQ0FBQyxDQUFDLFdBQUksS0FBSyxDQUFFLENBQUMsQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFDO1FBQzNCLE9BQU8sS0FBSyxDQUFBO0tBQ2I7SUFFRCxJQUFJLGFBQWEsR0FBRztRQUNsQixPQUFPLEVBQUUsSUFBSTtRQUNiLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTTtRQUNuQixNQUFNLEVBQUUsYUFBYSxDQUFDLElBQUksQ0FBQztRQUMzQixLQUFLLEVBQUUsS0FBSztRQUNaLEtBQUssRUFBRSxHQUFHO1FBQ1YsTUFBTSxFQUFFLEdBQUc7UUFDWCxRQUFRLEVBQUUsS0FBSztRQUNmLEtBQUssRUFBRSxLQUFLO1FBQ1osYUFBYSxFQUFFLElBQUk7UUFDbkIsR0FBRyxFQUFFLEdBQUc7UUFDUixHQUFHLEVBQUUsSUFBSTtRQUNULFFBQVEsRUFBRSxJQUFJO1FBQ2QsUUFBUSxFQUFFLFFBQVE7S0FDbkIsQ0FBQztJQUNGLElBQUksR0FBRyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLGFBQWEsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUNoRCxJQUFBLG9CQUFRLEVBQUMsR0FBRyxDQUFDLENBQUM7QUFDaEIsQ0FBQztBQTlCRCxrQ0E4QkMifQ==